module.exports = __webpack_public_path__ + "img/IM.34a14428.svg";